import React from 'react';
import { Navigate } from 'react-router-dom';
import { useControlAuth } from '../ControlAuthContext';
import './ControlRoute.css';

const ControlRoute = ({ children }) => {
  const { user, loading } = useControlAuth();

  if (loading) {
    return (
      <main className="control-route-loading" aria-live="polite">
        <span className="control-route-spinner" aria-hidden="true" />
        <strong>Restoring your workspace</strong>
        <small>Validating the secure control session…</small>
      </main>
    );
  }

  return user ? children : <Navigate to="/control-login" replace />;
};

export default ControlRoute;
